<script setup lang="ts">
import TheLayoutApp from "@/Layouts/TheLayoutApp.vue";
import AppPage from "@/Components/Shared/page/AppPage.vue";
import AppContainer from "@/Components/Shared/container/AppContainer.vue";
import AppHeader from "@/Components/Shared/header/AppHeader.vue";
import AppTitle from "@/Components/Shared/title/AppTitle.vue";
import AppProductGrid from "@/Components/Shared/product/AppProductGrid.vue";
import AppDivider from "@/Components/Shared/divider/AppDivider.vue";
import AppLink from "@/Components/Shared/link/AppLink.vue";
import AppPlaceholder from "@/Components/Shared/placeholder/AppPlaceholder.vue";

type Props = {
    category: object;
    family: object;
    popularProducts: object;
    networkProducts?: object;
    moreInTheme?: object;
};

const {
    category,
    family,
    popularProducts,
    networkProducts = undefined,
    moreInTheme = undefined,
} = defineProps<Props>();

const breadcrumbs = [
    {
        label: "Producten",
        path: "/producten",
    },
];

if (category.data) {
    if (category.data.theme) {
        breadcrumbs.push({
            label: category.data.theme.name,
            path: category.data.theme.path,
        });
    }

    if (category.data.parents && category.data.parents.data) {
        category.data.parents.data.forEach(p => {
            if (p.theme) {
                breadcrumbs.push({
                    label: p.theme.name,
                    path: p.theme.path,
                });
            }

            breadcrumbs.push({
                label: p.name,
                path: p.path,
            });
        });
    }

    if (category.data.parent) {
        breadcrumbs.push({
            label: category.data.parent.name,
            path: category.data.parent.path,
        });
    }
}
</script>

<template>
    <TheLayoutApp
        :title="`${category.data.name}`"
        :description="`Ontdek alle reviews voor ${category.data.name} via geschreven aanbevelingen, gemaakte collecties en meer. Ontdek de kracht van collectieve aanbevelingen. Welke ${category.data.name} zou jij aanraden?`"
        :breadcrumbs="breadcrumbs"
    >
        <AppPage size="small">
            <AppContainer size="large">
                <AppHeader>
                    <AppTitle size="large">
                        {{ category.data.name }}
                    </AppTitle>
                </AppHeader>

                <section
                    v-if="
                        networkProducts &&
                        networkProducts.data &&
                        networkProducts.data.length
                    "
                    class="mb-12"
                >
                    <AppHeader>
                        <AppTitle as="h2">
                            Aangeraden door je netwerk
                        </AppTitle>
                    </AppHeader>

                    <AppProductGrid
                        :products="networkProducts.data"
                        size="large"
                    />
                </section>

                <section>
                    <AppHeader>
                        <AppTitle as="h2"> Populair </AppTitle>
                    </AppHeader>

                    <template
                        v-if="
                            popularProducts &&
                            popularProducts.data &&
                            popularProducts.data.length
                        "
                    >
                        <AppProductGrid
                            :products="popularProducts.data"
                            size="large"
                        />

                        <AppDivider spacing="large">
                            <AppLink
                                color="primary"
                                :href="`/zoeken?categories[]=${category.data.id}`"
                                variant="button"
                            >
                                bekijk alle producten →
                            </AppLink>
                        </AppDivider>
                    </template>
                    <AppPlaceholder v-else>
                        Nog geen producten gevonden
                    </AppPlaceholder>
                </section>
            </AppContainer>
        </AppPage>

        <!--        <template #sidebar>-->
        <!--            <div class="flex flex-col gap-8">-->
        <!--                <section-->
        <!--                    v-if="family.length"-->
        <!--                    class="p-6 pb-8 bg-theme rounded-sm"-->
        <!--                >-->
        <!--                    <AppHeader>-->
        <!--                        <AppTitle-->
        <!--                            as="h2"-->
        <!--                            variant="subtitle"-->
        <!--                        >-->
        <!--                            Gerelateerde categorieen-->
        <!--                        </AppTitle>-->
        <!--                    </AppHeader>-->

        <!--                    <AppBadgeGroup>-->
        <!--                        <AppBadge-->
        <!--                            v-for="category in family"-->
        <!--                            :href="category.path"-->
        <!--                        >-->
        <!--                            {{ category.name }}-->
        <!--                        </AppBadge>-->
        <!--                    </AppBadgeGroup>-->
        <!--                </section>-->

        <!--                <section-->
        <!--                    v-if="-->
        <!--                        moreInTheme &&-->
        <!--                        moreInTheme.data &&-->
        <!--                        Object.keys(moreInTheme.data).length-->
        <!--                    "-->
        <!--                    class="p-6 pb-8 bg-themeSecondary rounded-sm"-->
        <!--                >-->
        <!--                    <AppHeader>-->
        <!--                        <AppTitle-->
        <!--                            as="h2"-->
        <!--                            color="primary"-->
        <!--                            variant="subtitle"-->
        <!--                        >-->
        <!--                            Meer in dit thema-->
        <!--                        </AppTitle>-->
        <!--                    </AppHeader>-->

        <!--                    <AppBadgeGroup>-->
        <!--                        <AppBadge-->
        <!--                            v-for="category in moreInTheme.data"-->
        <!--                            :href="category.path"-->
        <!--                        >-->
        <!--                            {{ category.name }}-->
        <!--                        </AppBadge>-->
        <!--                    </AppBadgeGroup>-->
        <!--                </section>-->

        <!--                <section v-if="users && users.data && Object.keys(users.data).length">-->
        <!--                    <AppHeader>-->
        <!--                        <AppTitle-->
        <!--                            as="h3"-->
        <!--                            variant="subtitle"-->
        <!--                            color="gray"-->
        <!--                        >-->
        <!--                            Aangeraden door-->
        <!--                        </AppTitle>-->
        <!--                    </AppHeader>-->

        <!--                    <AppUserGrid-->
        <!--                        :users="users.data"-->
        <!--                    />-->
        <!--                </section>-->
        <!--            </div>-->
        <!--        </template>-->
    </TheLayoutApp>
</template>
